import * as React from "react";
const SvgUnknownProfile = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-03d672c3-c080-4bc1-8cb2-cd5bb97d1fe0", "data-name": "Warstwa 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 7.75, style: {
  fill: "#e5e5e5",
  stroke: "#e5e5e5",
  strokeWidth: ".5px"
} }));
export default SvgUnknownProfile;
